<template>
  <div id="RegisterDetailDialog_main">
    <el-dialog
      title="報到明細"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <el-form
        label-position="right"
        label-width="140px"
        :model="data"
      >
        <el-form-item label="戶別">
          {{ data.tabletName }}
        </el-form-item>
        <el-form-item :label="areaPerPerson">
          {{ data.tabletArea }}
          {{ unit }}
        </el-form-item>
        <el-form-item label="區分所有權佔比">
          <span v-if="data.tabletAreaRatio < 0.01">＜0.01％</span>
          <span v-else>{{ data.tabletAreaRatio }}％</span>
        </el-form-item>
        <el-form-item label="報到狀態">
          <el-tag
            v-if="data.registrationStatus === 'NotRegistered'"
            type="info"
          >
            未報到
          </el-tag>
          <el-tag
            v-else-if="data.registrationStatus === 'Registered'"
            type="success"
          >
            已報到
          </el-tag>
          <el-tag
            v-else
            type="warning"
          >
            已簽退
          </el-tag>
        </el-form-item>
        <el-form-item label="報到人身份">
          <div v-if="data.registrationStatus !== 'NotRegistered'">
            <span v-if="data.isRepresented">委託</span>
            <span v-else>本人</span>
          </div>
        </el-form-item>
        <el-form-item label="報到時間">
          {{ data.registerAt }}
        </el-form-item>
        <el-form-item label="簽退時間">
          {{ data.unregisterAt }}
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import tw from '../utils'
export default {
  data () {
    const { areaPerPerson, unit } = tw
    return {
      areaPerPerson,
      unit,
      dialogVisible: false,
      data: {}
    }
  },
  methods: {
    openDetailDialog (data) {
      this.dialogVisible = true
      this.data = data
    }
  }
}
</script>
<style lang="sass" scoped>
#RegisterDetailDialog_main
  ::v-deep .el-dialog
    +basicDialog
    min-width: 540px
    .el-form
      text-align: left
      .el-form-item
        margin-bottom: 15px
        .el-form-item__label
          font-weight: bold
</style>
